export default __webpack_public_path__ + "static/logo-home-b28cf8446d7fbbd9b9c870b3a2cf593c.svg";